import { apiRequest } from "../util/apiUtils";

export const getCartList = async (params) => {
  try {
    const res = await apiRequest("get", "/cart/my-cart", {
      queries: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};

export const addToCartProduct = async (params) => {
  try {
    const res = await apiRequest(
      "patch",
      "/cart/add-to-cart",
      {
        body: { ...params },
      }
      // "multipart/form-data"
    );
    return res;
  } catch (error) {
    return error;
  }
};
export const deleteCart = async (params) => {
  try {
    const res = await apiRequest("patch", "/cart/remove-cart-item", {
      body: { ...params },
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const checkout = async (params) => {
  try {
    const res = await apiRequest("post", "/order/checkout", {
      body: { ...params },
    });
    return res;
  } catch (error) {
    return error;
  }
};
export const placeOrder = async (params) => {
  try {
    const res = await apiRequest("post", "/order/place-order", {
      body: { ...params },
    });
    return res;
  } catch (error) {
    return error;
  }
};
